import React from 'react';
import { useField, useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { getCountry } from '@swf/core/utils/phoneVerification';
import countries from '@swf/generated/countries.json';

import City from '../../../../../City/City';
import RMFDropDown from '../../../RMFDropDown/RMFDropDown';

import {
  TXTWCL_City_of_birth,
  TXTWCL_Country_of_birth,
  TXTWCL_If_not_applicable_please_enter_ELL
} from './PlaceOfBirthFieldsDE.messages.json';
import { city, wrapper } from './PlaceOfBirthFieldsDE.scss';

const countryOfBirthField = 'countryOfBirth';
const cityOfBirthField = 'cityOfBirth';
const MAX_LENGTH = 85;
const MIN_LENGTH = 1;

const PlaceOfBirthFieldsDE = () => {
  const form = useForm();
  const country = useSelector(select.account.getCountry) as string;
  const initialCountry = country === Country.Germany ? Country.Germany : country;

  useField(countryOfBirthField, { initialValue: initialCountry });
  useField(cityOfBirthField);

  const countryName = country && getCountry(country)?.text;

  const resetCityState = () => {
    form.change(cityOfBirthField);
    form.resetFieldState(cityOfBirthField);
  };

  return (
    <div className={wrapper}>
      <RMFDropDown
        id={countryOfBirthField}
        label={TXTWCL_Country_of_birth}
        options={countries}
        onSelect={resetCityState}
        placeholder={countryName}
      />
      <City
        fieldName={cityOfBirthField}
        requiredMessage={TXTWCL_If_not_applicable_please_enter_ELL}
        label={TXTWCL_City_of_birth}
        className={city}
        maxLength={MAX_LENGTH}
        minLength={MIN_LENGTH}
        isDe
      />
    </div>
  );
};

export default PlaceOfBirthFieldsDE;
